module.exports = __webpack_public_path__ + "img/991213779.9f75ce83.jpg";